const Config = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL,
    GOOGLE_AUTH_ID: process.env.REACT_APP_GOOGLE_AUTH_ID,
    // Public Meta App ID used to build the client-driven Facebook OAuth dialog
    // URL (see components/Datasources/MetaAuth/useMetaLogin.js). App IDs are
    // not secret (unlike META_APP_SECRET, which stays server-side only in
    // cq-api) — this mirrors GOOGLE_AUTH_ID's client-exposed public-client-id
    // pattern above. Must be set to the same value as cq-api's META_APP_ID.
    META_APP_ID: process.env.REACT_APP_META_APP_ID,
    // Public Instagram App ID (distinct from META_APP_ID) required as the
    // `client_id` for Meta's "Instagram API with Instagram Login" OAuth
    // dialog (instagram.com/oauth/authorize) — see
    // components/Datasources/MetaAuth/useInstagramLogin.js. Not secret, same
    // client-exposed pattern as META_APP_ID above. Must be set to the same
    // value as cq-api's INSTAGRAM_APP_ID.
    INSTAGRAM_APP_ID: process.env.REACT_APP_INSTAGRAM_APP_ID,
    // Shopify embedded-app install/auth (TRD:
    // docs/product/features/completed/shopify-embedded-install-auth/trd.md,
    // Bounded Unit B1). This is the app's own Shopify API (client) key, used
    // only to initialize App Bridge inside the embedded iframe -- distinct
    // from SHOPIFY_CLIENT_ID above, which is the data-source-connection
    // OAuth client id for a merchant's own project-as-data-source flow.
    // Public/frontend-safe by design (App Bridge requires it client-side);
    // never the corresponding backend-only client secret.
    SHOPIFY_API_KEY: process.env.REACT_APP_SHOPIFY_API_KEY,
    // Shopify app handle/slug, used to build the
    // https://admin.shopify.com/store/<shop>/apps/<app-handle> deep-link
    // B4.2's top-level redirect guard sends a non-embedded Shopify-origin
    // visitor to.
    SHOPIFY_APP_HANDLE: process.env.REACT_APP_SHOPIFY_APP_HANDLE,
};

export default Config;
